export const AuditFieldsConstants = {
  ID: "id",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  MODIFIED_BY: "modifiedBy",
  MODIFIED_DATE: "modifiedDate",
  DELETED_AT: "deletedAt",
}
